import { render, staticRenderFns } from "./modalComprasAfiliado.vue?vue&type=template&id=2e0fa7e5&scoped=true&"
import script from "./modalComprasAfiliado.vue?vue&type=script&lang=js&"
export * from "./modalComprasAfiliado.vue?vue&type=script&lang=js&"
import style0 from "./modalComprasAfiliado.vue?vue&type=style&index=0&id=2e0fa7e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0fa7e5",
  null
  
)

export default component.exports